export const actionTypes = {
    GET_GRAPH_SUMMARY: 'GET_GRAPH_SUMMARY',
    GET_GRAPH_SUMMARY_SUCCESS: 'GET_GRAPH_SUMMARY_SUCCESS',
    GET_GRAPH_SUMMARY_FAIL: 'GET_GRAPH_SUMMARY_FAIL',

    GET_USER_SUMMARY: 'GET_USER_SUMMARY',
    GET_USER_SUMMARY_SUCCESS: 'GET_USER_SUMMARY_SUCCESS',
    GET_USER_SUMMARY_FAIL: 'GET_USER_SUMMARY_FAIL',

    GET_BRIK_SUMMARY: 'GET_BRIK_SUMMARY',
    GET_BRIK_SUMMARY_SUCCESS: 'GET_BRIK_SUMMARY_SUCCESS',
    GET_BRIK_SUMMARY_FAIL: 'GET_BRIK_SUMMARY_FAIL',
};

export const actions = {
    getBriksSummary: () => ({
      type: actionTypes.GET_BRIK_SUMMARY,
    }),
    getBriksSummarySuccess: (data: unknown) => ({
      type: actionTypes.GET_BRIK_SUMMARY_SUCCESS,
      payload: data,
    }),
    getBriksSummaryFail: (err: unknown) => ({
      type: actionTypes.GET_BRIK_SUMMARY_FAIL,
      payload: err,
    }),

    getGraphSummary: () => ({
      type: actionTypes.GET_GRAPH_SUMMARY,
    }),
    getGraphSummarySuccess: (data: unknown) => ({
      type: actionTypes.GET_GRAPH_SUMMARY_SUCCESS,
      payload: data,
    }),
    getGraphSummaryFail: (err: unknown) => ({
      type: actionTypes.GET_GRAPH_SUMMARY_FAIL,
      payload: err,
    }),

    getUserSummary: () => ({
      type: actionTypes.GET_USER_SUMMARY,
    }),
    getUserSummarySuccess: (data: unknown) => ({
      type: actionTypes.GET_USER_SUMMARY_SUCCESS,
      payload: data,
    }),
    getUserSummaryFail: (err: unknown) => ({
      type: actionTypes.GET_USER_SUMMARY_FAIL,
      payload: err,
    }),
  };